import {DATE_FORMATS, TIME_FORMATS} from "constants/AppConstants.js";

export default class ValidUtil {
  static isDateValid(date: any): boolean {
    // new Date(null) coerces to the epoch instead of an Invalid Date, so null needs its own check.
    return date !== null && new Date(date).toString() !== "Invalid Date" && !isNaN(new Date(date).valueOf());
  }

  static isDateFormatValid(format: string): boolean {
    const values = Object.values(DATE_FORMATS);
    return values.includes(format);
  }

  static isTimeFormatValid(format: string): boolean {
    const values = Object.values(TIME_FORMATS);
    return values.includes(format);
  }
}
